import useAvailableIntegrations from '../../hooks/useAvailableIntegrations'

import AddIntegrationButton from './AddIntegrationButton'
import IntegrationItem from './IntegrationItem'
import { Options } from './interfaces'

const IntegrationsMenu = ({
  options,
  onClick,
}: {
  options: Options[]
  onClick: (key: string) => void
}) => {
  const { data } = useAvailableIntegrations()

  const unavailableIntegrations = options?.filter(
    ({ provider }) => !data?.includes(provider)
  )

  const availableIntegrations = options?.filter(({ provider }) =>
    data?.includes(provider)
  )

  return (
    <div
      className="updated-component z-40 px-4 pt-2 bg-gold-50 border border-gold-200 min-w-60"
      data-testid="integrations-menu"
    >
      {availableIntegrations?.length > 0 && (
        <div
          key="available-integrations"
          aria-label="Available for this channel"
        >
          {availableIntegrations.map((option, index) => {
            const { key, label, logoUrl, provider } = option

            return (
              <IntegrationItem
                key={key}
                logoUrl={logoUrl}
                alt={`${provider}-logo-${index}`}
                label={label}
                onSelect={() => onClick(key.toString())}
              />
            )
          })}
        </div>
      )}

      {unavailableIntegrations?.length > 0 && (
        <div
          aria-label="Unavailable for this channel"
          key="unavailable-integrations"
          className="pt-2"
        >
          <div className="text-base-700 font-medium text-sm px-4 -mx-4 py-1">
            Unavailable for this channel
          </div>
          {unavailableIntegrations.map((option, index) => {
            const { key, label, logoUrl, provider } = option

            return (
              <IntegrationItem
                isDisabled
                key={key}
                logoUrl={logoUrl}
                alt={`${provider}-logo-${index}`}
                label={label}
              />
            )
          })}
        </div>
      )}

      <hr className="border-gold-200 my-1 -mx-4" />
      <AddIntegrationButton onSelect={() => onClick('redirect')} />
    </div>
  )
}

export default IntegrationsMenu
